module.exports = __webpack_public_path__ + "img/icon_request.d83dfd8.png";